// extracted by mini-css-extract-plugin
module.exports = {"summary__stats":"H_cV","summary__stats__links":"H_cW","summary__stats__links__single":"H_cX"};